
export const REQUEST_REFER_FRIEND = 'header/REQUEST_REFER_FRIEND';
export const REQUEST_SEARCH_QUERY = 'header/REQUEST_SEARCH_QUERY';
export const REQUEST_ADD_TO_LIBRARY = 'header/REQUEST_ADD_TO_LIBRARY';
